var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.788 0.0087373C18.1808 -0.0852776 17.6789 0.598926 18.0653 1.12297C25.0733 10.5922 18.0928 24.4783 6.37083 24.3776C4.48729 24.3776 2.66411 24.0224 0.952825 23.3225C0.456064 23.0997 -0.123491 23.6028 0.0231085 24.1321C2.12915 32.886 9.84441 39 18.7861 39C44.4071 37.9293 44.4022 1.0776 18.7861 0.0106094L18.788 0.0087373ZM18.788 37.6053C10.9241 37.6053 4.08162 32.5146 1.71881 25.0719C11.6677 28.3032 22.407 20.3364 22.2379 9.75653C22.2379 6.78464 21.4462 3.9362 19.9352 1.43808C42.8551 3.73443 41.8841 36.7576 18.7899 37.6053H18.788Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMoon);
export default __webpack_public_path__ + "static/media/icn-moon.623844863342ae6fe8bc49bd968d5205.svg";
export { ForwardRef as ReactComponent };